var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"modal-close-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('CancelIcon',{attrs:{"fill-color":"var(--80)"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }